import Label from '../../../../../ui/label';
import { useDispatch } from 'react-redux';
import { setBMSR, toggleRider } from '../../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice';
import { addRiderSalaryRankInput, removeRiderSalaryRankInput } from '../../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice';
import { addRiderLevelRankingInput, removeLevelRankingRiderInput } from '../../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice';
import { addAmountOfLoansRider, removeAmountOfLoansRider } from '../../../../../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice';
import { addOrUpdateUniformCoverageRider, removeRiderUniformCoverageInput } from '../../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice';
import LoadingCategory from '../../../../../ui/loading-category';
import ErrorFetch from '../../../../../ui/error-fetch-category';
import { defaultAmountByRider, PROPOSAL_RIDERS } from '../../../../../../constant/gms-constant';
import { useCoverageInputsValidation } from '../../../../../../hooks/validations/user-coverage-inputs-validation';
import { useQueries } from '../../../../../../hooks/services/queries/use-queries';
import { SubTypeOption } from '../../../../../../api/gms/group-category/group-category-api-state';
import Checkbox from '../../../../../ui/checkbox';
import { useProposalTypeData } from '../../../../../../hooks/proposal/use-proposal-type-data';

export default function AttachableCheckbox() {

    const dispatch = useDispatch()
    const { isValidCoverageInputs } = useCoverageInputsValidation();
    const { 
        inputsByLevelRanking,
        inputsBySalaryRank,
        ridersLevelRanking,
        ridersSalaryRank,
        riders,
        basicPlan,
        product: selectedProduct,
    } = useProposalTypeData();
    const { typeOfProduct, isLoadingTypeOfProduct, isErrorTypeOfProduct, } = useQueries()
    const product = typeOfProduct?.find((p: any) => p.product_id === selectedProduct?.id);
    const basicPlansData = product?.basic_plans;
    const selectedBasicPlan = basicPlansData?.find((plan) => plan.basic_plan_id === basicPlan?.id);

    // Get its riders
    const mappedOptions: SubTypeOption[] = selectedBasicPlan?.riders.map(item => ({
        id: item.rider_id,
        name: item.rider_name
    })) || [];
    const handleCheckedBoxAttachableRiders = (e: React.ChangeEvent<HTMLInputElement>, rider: SubTypeOption) => {
    
        // for disabled rider
        if (rider.id === PROPOSAL_RIDERS.GMR.productFor.GYRT) return;
    
        const checked = e.target.checked;

        const isValid = isValidCoverageInputs();
        if (!isValid) return;

        // call only this if the id/rider is ALCR
        // if (Object.values(PROPOSAL_RIDERS.ALCR.productFor).some((riderId) => riderId === rider.id) && !checked) {
        //     dispatch(setBorrowerAgeValue({ id: 3, value: false, type: 'fAge' }));
        //     dispatch(setBorrowerAgeValue({ id: 4, value: false, type: 'fAge' }));
        //     dispatch(setBorrowerAgeValue({ id: 5, value: false, type: 'fAge' }));
        // }

        // Toggle selection in global selectedRiders
        dispatch(toggleRider({ id: rider.id, label: rider.name }));

        if (Object.values(PROPOSAL_RIDERS.BMSR.productFor).some((riderId) => riderId === rider.id) && checked) {
            dispatch(
                setBMSR({
                    id: rider.id,
                    label: rider.name,
                    inputs: [{ fAmount: 50000 }],
                })
            )
        }

        // Handle coverage-type riders
        if (checked) {
            // Level Ranking
            const exists = ridersLevelRanking?.some(r => r.id === rider.id);
            if (!exists) {
                const dynamicInputs = inputsByLevelRanking.map(input => ({
                    label: input.label,
                    fAmount: defaultAmountByRider[Number(rider.id)] ?? input.fAmount,
                }));
                
                dispatch(addRiderLevelRankingInput({
                    id: rider.id,
                    label: rider.name,
                    inputs: dynamicInputs
                }));
            }
            // By Salary Rank
            const existsSalaryByRank = ridersSalaryRank?.some(r => r.id === rider.id);
            if (!existsSalaryByRank) {
                const dynamicInputsBySalaryRank = inputsBySalaryRank.map(input => ({
                    id: input.id,
                    multiplierLabel: input.multiplierLabel,
                    multiplierValue: input.multiplierValue,
                    salary: input.salary,
                    designation: input.designation,
                    result: defaultAmountByRider[Number(rider.id)] ?? input.result,
                    checked: input.checked,
                }));
                dispatch(addRiderSalaryRankInput({ 
                    id: rider.id, 
                    label: rider.name,
                    riderValues: dynamicInputsBySalaryRank
                }));
            }
            // Uniform
            dispatch(addOrUpdateUniformCoverageRider({
                id: rider.id,
                label: rider.name,
            }));

            dispatch(addAmountOfLoansRider({ 
                id: rider.id, 
                label: rider.name,
            }));
        } else {
            // Remove all coverage-type inputs if unchecked
            dispatch(removeLevelRankingRiderInput(rider.id));
            dispatch(removeRiderUniformCoverageInput(rider.id));
            dispatch(removeRiderSalaryRankInput(rider.id));
            dispatch(removeAmountOfLoansRider(rider.id));
        }
    }
    
    const isCustomizeStyle = isErrorTypeOfProduct || isLoadingTypeOfProduct

    return (
        <div className="w-full overflow-hidden bg-white">
            {/* ================================================= */}
            {/* HEADER */}
            {/* ================================================= */}
            <div className="border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-3 py-3 sm:px-4 sm:py-3.5">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    {/* TITLE & DESCRIPTION */}
                    <div className="flex min-w-0 items-start gap-2.5">
                        <div className="min-w-0">
                            <Label
                                label="Attachable Riders"
                                fontWeight="font-semibold text-gray-800"
                                fontSize="text-xs"
                            />
                            <p className="mt-0.5 text-[10px] leading-4 text-gray-500 sm:text-[11px]">
                                Select the riders you want to include in this
                                proposal.
                            </p>
                        </div>
                    </div>
                    {/* SELECTED COUNT */}
                    <div className="flex w-fit shrink-0 items-center gap-1.5 rounded-md border border-[#186cb2]/20 bg-white px-2.5 py-1.5 text-[11px] font-semibold text-[#186cb2] shadow-sm sm:px-3 sm:text-[11px]">
                        {/* CHECK ICON */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="m5 12 4 4L19 6" />
                        </svg>
                        <span>
                            {riders.length} Selected
                        </span>
                    </div>
                </div>
            </div>

            {/* RIDERS */}
            <div className={`grid gap-2 p-3 sm:p-4 ${ isCustomizeStyle ? 'grid-cols-1' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' } `} >
                {isLoadingTypeOfProduct ? (
                    <LoadingCategory />
                ) : isErrorTypeOfProduct ? (
                    <ErrorFetch />
                ) : (
                    mappedOptions.map((rider) => {
                        const isSelected = riders.some(r => r.id === rider.id );
                        const isDisabled = rider.name === 'Group Medical Rider';

                        return (
                            <Checkbox 
                                key={rider.id}
                                disabled={isDisabled} 
                                option={rider} 
                                isSelected={isSelected} 
                                onChange={handleCheckedBoxAttachableRiders}
                            />
                        );
                    })
                )}
            </div>
        </div>
    );
}